export default __webpack_public_path__ + "static/media/17.0eb8d7c4.jpg";